import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// const container = document.getElementById("root");
// const root = createRoot(container);
// root.render(<App />);
